.table {
  width: 100%;
}

/* Was a shared `headerCellStyles` css fragment interpolated into both
   components; one rule with two selectors expresses the same thing. */
.header-cell,
.sortable-cell {
  color: var(--color-grayscale-shuttle);
  font-size: 1.4rem;
  font-weight: 400;
  text-align: left;
  width: 1%;
  white-space: nowrap;

  &:nth-child(4) {
    width: 100%;
  }

  &:not(:last-child) {
    padding-right: 9.6rem;
  }
}
